import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import News from './News/News';
import logo from "../Header/Images/RMB-Strip-Jaipur.png";
import {
  MdSpaceDashboard, MdPostAdd, MdRateReview, MdClose, MdMenu
} from "react-icons/md";
import Member from './Member';
import {
  FaUsers, FaCalendarAlt, FaUserTag, FaUsersCog,
  FaAward, FaHistory, FaGoogleDrive, FaUserShield,
  FaCalendarCheck, FaChartBar, FaRobot, FaCog
} from "react-icons/fa";
import ActivityVerification from './ActivityVerification';
import MembershipAuditTrail from './MembershipAuditTrail';
import RoleManagement from './RoleManagement';
import CommitteeManagement from './CommitteeManagement';
import ChatGPTAdminStudio from './ChatGPTAdminStudio';
import HomeBanner from './Banners/HomeBanner';
import { IoMdArrowDropdownCircle } from "react-icons/io";
import { IoImagesSharp } from "react-icons/io5";
import { PiGiftBold, PiSelectionBackgroundFill, PiPresentationChart } from "react-icons/pi";
import { CgArrowLongRightC } from "react-icons/cg";
import { BiSolidContact } from "react-icons/bi";
import { GiOpenFolder } from "react-icons/gi";
import AboutBanner from './Banners/AboutBanner';
import MemberBanner from './Banners/MemberBanner';
import MeetingsBanner from './Banners/MeetingsBanner';
import DirectorsBanner from './Banners/DirectorsBanner';
import ContactBanner from './Banners/ContactBanner';
import { TfiGallery } from "react-icons/tfi";
import Gallery from './Gallery/Gallery';
import Testimonials from './Testimonial/Testimonials';
import About from './Pages/About';
import RMBLeader from './Pages/RMBLeader';
import RMBJaipur from './Pages/RMBJaipur';
import MemberPage from './Pages/MemberPage';
import MeetingPage from './Pages/MeetingPage';
import LeadershipPage from './Pages/LeadershipPage';
import ContactPage from './Pages/ContactPage';
import GetInTouch from './Form/GetInTouch';
import EventsCalendar from './EventsCalendar';
import ReportsAnalytics from './Reports/ReportsAnalytics';
import Point from './Points/Point';
import Attendance from './Attendance/Attendance';
import MemberEditPage from './MemberEditPage';
import RbacManagement from './RbacManagement';
import NewsMediaAdmin from './NewsMediaAdmin';
import DashboardOverview from './DashbordOverview';
import GoogleDriveAdmin from './GoogleDriveAdmin';
import SystemSettingsAdmin from './SystemSettingsAdmin';
import HomeSectionLayoutAdmin from './HomeSectionLayoutAdmin';
import ChapterManagement from './ChapterManagement';
import NoShowReport from './NoShowReport';
import TotalConnectionsReport from './Reports/TotalConnectionsReport';
import VisitorListReport from './Reports/VisitorListReport';
import { FaBuilding, FaUserTimes, FaHandshake } from 'react-icons/fa';

// --- Sidebar Nav Item Component ---
interface SidebarItemProps {
  icon: React.ReactNode;
  label: string;
  tabKey: string;
  activeTab: string;
  onClick: (tab: string) => void;
  highlight?: boolean;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ icon, label, tabKey, activeTab, onClick, highlight }) => (
  <button
    onClick={() => onClick(tabKey)}
    className={`w-full h-12 flex items-center gap-3 px-4 text-sm font-semibold cursor-pointer transition-all duration-150 text-left
      ${activeTab === tabKey
        ? 'bg-[#FDBC12]/15 border-r-4 border-[#FDBC12] text-[#FDBC12]'
        : 'text-slate-300 hover:text-[#FDBC12] hover:bg-white/5'
      }`}
  >
    <span className={`text-xl flex-shrink-0 ${highlight ? 'text-[#FDBC12]' : ''}`}>{icon}</span>
    <span className="truncate">{label}</span>
  </button>
);

// --- Sidebar Group Header ---
const SidebarGroupLabel: React.FC<{ label: string }> = ({ label }) => (
  <div className="px-4 pt-4 pb-1">
    <span className="text-[10px] font-black uppercase tracking-widest text-slate-500">{label}</span>
  </div>
);

// --- Collapsible Sidebar Section ---
interface SidebarGroupProps {
  icon: React.ReactNode;
  label: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}
const SidebarGroup: React.FC<SidebarGroupProps> = ({ icon, label, isOpen, onToggle, children }) => (
  <>
    <button
      onClick={onToggle}
      className="w-full h-12 flex items-center gap-3 px-4 text-sm font-semibold cursor-pointer text-slate-300 hover:text-[#FDBC12] hover:bg-white/5 transition-all duration-150 relative"
    >
      <span className="text-xl flex-shrink-0">{icon}</span>
      <span className="truncate">{label}</span>
      <IoMdArrowDropdownCircle
        className={`absolute right-4 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
      />
    </button>
    {isOpen && (
      <div className="border-l-2 border-[#FDBC12]/30 ml-4">
        {children}
      </div>
    )}
  </>
);

const SidebarSubItem: React.FC<{ label: string; tabKey: string; activeTab: string; onClick: (tab: string) => void }> = ({
  label, tabKey, activeTab, onClick
}) => (
  <button
    onClick={() => onClick(tabKey)}
    className={`w-full h-9 flex items-center gap-2 pl-5 pr-3 text-xs font-semibold cursor-pointer transition-all duration-150 text-left
      ${activeTab === tabKey
        ? 'text-[#FDBC12] bg-[#FDBC12]/10'
        : 'text-slate-400 hover:text-[#FDBC12] hover:bg-white/5'
      }`}
  >
    <CgArrowLongRightC className="flex-shrink-0" />
    <span className="truncate">{label}</span>
  </button>
);

// --- Main Dashboard Component ---
interface UserDetails {
  id: number;
  name: string;
  email: string;
  profile?: string;
}

const Dashboard = () => {
  const navigate = useNavigate();
  const [tabs, setTabs] = useState<string>("Dashbord");
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const [editingUserId, setEditingUserId] = useState<number | null>(null);
  const [memberFilter, setMemberFilter] = useState<string>('');
  const [bannerMenuOpen, setBannerMenuOpen] = useState(false);
  const [pageMenuOpen, setPageMenuOpen] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const [theme, setTheme] = useState<'dark' | 'light'>(() => {
    return (localStorage.getItem('APP_THEME') as 'dark' | 'light') || 'dark';
  });

  useEffect(() => {
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [theme]);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    localStorage.setItem('APP_THEME', next);
  };

  const handleNavigateToMembers = (filter: string) => {
    setMemberFilter(filter);
    setTabs("Member");
  };

  const handleTabClick = (tab: string) => {
    setTabs(tab);
    setMobileSidebarOpen(false);
  };

  useEffect(() => {
    const validateSession = async () => {
      try {
        const response = await axios.get('https://rmbbackend.rmbjaipur.com/auth/dashboard', {
          withCredentials: true,
        });
        const uid = response.data.userId;
        const userResponse = await axios.get(`https://rmbbackend.rmbjaipur.com/auth/user/${uid}`, {
          withCredentials: true,
        });
        const u = Array.isArray(userResponse.data) ? userResponse.data[0] : userResponse.data;
        setUserDetails(u);
      } catch {
        navigate('/login');
      }
    };
    validateSession();
  }, [navigate]);

  // Build the sidebar JSX (shared between desktop and mobile drawer)
  const sidebarContent = (
    <div className="flex flex-col h-full">
      {/* Logo */}
      <div className="px-4 py-4 border-b border-white/10 flex-shrink-0">
        <img src={logo} alt="RMB Jaipur Logo" className="w-full max-w-[180px] rounded-lg bg-white p-2 shadow-lg" />
      </div>

      {/* User Badge */}
      {userDetails && (
        <div className="mx-3 mt-3 mb-1 bg-white/8 rounded-xl p-3 flex items-center gap-3 flex-shrink-0">
          <div className="w-9 h-9 rounded-full bg-[#FDBC12] flex items-center justify-center flex-shrink-0 text-[#0A2451] font-black text-base">
            {userDetails.name?.charAt(0).toUpperCase() || 'A'}
          </div>
          <div className="min-w-0">
            <p className="text-white text-xs font-bold truncate">{userDetails.name || 'Admin'}</p>
            <p className="text-slate-400 text-[10px] truncate">{userDetails.email || ''}</p>
          </div>
        </div>
      )}

      {/* Scrollable nav */}
      <div className="flex-1 overflow-y-auto sidebar-scroll py-2">
        {/* OVERVIEW */}
        <SidebarGroupLabel label="Overview" />
        <SidebarItem icon={<MdSpaceDashboard />} label="Dashboard" tabKey="Dashbord" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<FaCalendarAlt />} label="Events Calendar" tabKey="EventsCalendar" activeTab={tabs} onClick={handleTabClick} />

        {/* CONTENT */}
        <SidebarGroupLabel label="Content" />
        <SidebarItem icon={<IoImagesSharp />} label="Gallery" tabKey="Gallery" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<MdRateReview />} label="Testimonials" tabKey="Testimonial" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<MdPostAdd />} label="News & Media & Video" tabKey="NewsMediaAdmin" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<BiSolidContact />} label="Dynamic Forms & Enquiries" tabKey="FormDeatils" activeTab={tabs} onClick={handleTabClick} highlight />

        {/* MEMBERS */}
        <SidebarGroupLabel label="Members" />
        <SidebarItem icon={<FaUsers />} label="Member Management" tabKey="Member" activeTab={tabs} onClick={() => { setMemberFilter(''); handleTabClick('Member'); }} />
        <SidebarItem icon={<PiPresentationChart />} label="Attendance Sheet" tabKey="Attendance" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<FaHistory />} label="Membership Audit" tabKey="MembershipAuditTrail" activeTab={tabs} onClick={handleTabClick} />

        {/* OPERATIONS */}
        <SidebarGroupLabel label="Operations & System" />
        <SidebarItem icon={<FaChartBar />} label="Reports & Analytics" tabKey="ReportsAnalytics" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaAward />} label="Activity Approvals" tabKey="ActivityVerification" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<FaUserTag />} label="Roles & Designations" tabKey="RoleManagement" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<FaUsersCog />} label="Committee Manager" tabKey="CommitteeManagement" activeTab={tabs} onClick={handleTabClick} />
        <SidebarItem icon={<FaUserShield />} label="RBAC Control" tabKey="RbacManagement" activeTab={tabs} onClick={handleTabClick} highlight />

        <SidebarItem icon={<FaBuilding />} label="Whitelabel Chapters" tabKey="ChapterManagement" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaHandshake />} label="Total Connections Report" tabKey="TotalConnectionsReport" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaUserShield />} label="Chapter Visitors Report" tabKey="VisitorListReport" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaUserTimes />} label="RSVP No-Show Report" tabKey="NoShowReport" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<PiSelectionBackgroundFill />} label="Home Section Layout" tabKey="HomeSectionLayout" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaCog />} label="System & Society Years" tabKey="SystemSettingsAdmin" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaRobot />} label="ChatGPT AI Assistant" tabKey="ChatGPTStudio" activeTab={tabs} onClick={handleTabClick} highlight />
        <SidebarItem icon={<FaGoogleDrive />} label="Google Drive" tabKey="GDrive" activeTab={tabs} onClick={handleTabClick} />

        {/* PAGES */}
        <SidebarGroupLabel label="Pages" />
        <SidebarGroup icon={<GiOpenFolder />} label="Page Manager" isOpen={pageMenuOpen} onToggle={() => setPageMenuOpen(p => !p)}>
          <SidebarSubItem label="About RMB" tabKey="AboutRMB" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="RMB Leaders" tabKey="RMBLeader" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Member" tabKey="MemberPage" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="RMB Jaipur" tabKey="RMBJaipur" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Meetings" tabKey="MeetingPage" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Leadership" tabKey="LeadershipPage" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Contact" tabKey="ContactPage" activeTab={tabs} onClick={handleTabClick} />
        </SidebarGroup>

        <SidebarGroup icon={<PiSelectionBackgroundFill />} label="Banners" isOpen={bannerMenuOpen} onToggle={() => setBannerMenuOpen(p => !p)}>
          <SidebarSubItem label="Home Banner" tabKey="HomeBanner" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="About Banner" tabKey="AboutBanner" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Member Banner" tabKey="MemberBanner" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Meeting Banner" tabKey="MeetingBanner" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Director Banner" tabKey="DirectorBanner" activeTab={tabs} onClick={handleTabClick} />
          <SidebarSubItem label="Contact Banner" tabKey="ContactBanner" activeTab={tabs} onClick={handleTabClick} />
        </SidebarGroup>
      </div>

      {/* Logout */}
      <div className="flex-shrink-0 border-t border-white/10 p-3">
        <button
          onClick={() => {
            axios.post('https://rmbbackend.rmbjaipur.com/auth/logout', {}, { withCredentials: true })
              .finally(() => navigate('/login'));
          }}
          className="w-full py-2.5 text-xs font-bold text-slate-400 hover:text-red-400 hover:bg-red-400/10 rounded-xl transition-all cursor-pointer"
        >
          Sign Out
        </button>
      </div>
    </div>
  );

  return (
    <div className="flex bg-[#f0f4f8] min-h-screen">
      {/* === DESKTOP SIDEBAR === */}
      <aside className="hidden lg:flex flex-col w-[230px] xl:w-[250px] bg-[#0A2451] h-screen fixed top-0 left-0 z-30 shadow-2xl">
        {sidebarContent}
      </aside>

      {/* === MOBILE SIDEBAR DRAWER === */}
      {mobileSidebarOpen && (
        <div className="fixed inset-0 z-50 flex lg:hidden">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/50 backdrop-blur-sm"
            onClick={() => setMobileSidebarOpen(false)}
          />
          {/* Drawer */}
          <aside className="relative w-[260px] bg-[#0A2451] h-full shadow-2xl flex flex-col overflow-hidden">
            <button
              onClick={() => setMobileSidebarOpen(false)}
              className="absolute top-3 right-3 z-10 text-slate-400 hover:text-white p-1.5 rounded-lg hover:bg-white/10 transition-colors"
            >
              <MdClose size={20} />
            </button>
            {sidebarContent}
          </aside>
        </div>
      )}

      {/* === CONTENT AREA === */}
      <div className={`lg:ml-[230px] xl:ml-[250px] flex-1 min-h-screen transition-colors ${theme === 'light' ? 'bg-[#F8FAFC] text-slate-900' : 'bg-[#0B132B] text-slate-100'
        }`}>
        {/* Persistent Desktop & Mobile Top Bar with Theme Switcher */}
        <div className={`sticky top-0 z-20 flex items-center justify-between px-3 sm:px-6 py-2.5 sm:py-3 shadow-sm border-b transition-colors ${theme === 'light' ? 'bg-white/95 backdrop-blur-md border-slate-200 text-slate-900' : 'bg-[#0A2451]/95 backdrop-blur-md border-[#2A3B5C] text-white'
          }`}>
          <div className="flex items-center gap-2 sm:gap-3 min-w-0">
            <button
              onClick={() => setMobileSidebarOpen(true)}
              className="lg:hidden p-1.5 rounded-xl hover:bg-white/10 active:scale-95 transition-all text-amber-400"
              aria-label="Open sidebar drawer"
            >
              <MdMenu size={22} />
            </button>
            <img src={logo} alt="RMB Jaipur" className="h-6 sm:h-7 w-auto bg-white rounded-lg px-1.5 py-0.5 lg:hidden flex-shrink-0" />
            <h1 className="text-xs sm:text-base font-black flex items-center gap-1.5 capitalize truncate">
              {tabs === 'Dashbord' ? '📌 Executive Dashboard' : `⚙️ ${tabs.replace(/([A-Z])/g, ' $1').trim()}`}
            </h1>
          </div>

          <div className="flex items-center gap-1.5 sm:gap-2.5 flex-shrink-0">
            <button
              type="button"
              onClick={() => navigate('/user-dashboard')}
              className="px-2.5 py-1.5 sm:px-3.5 sm:py-1.5 rounded-full font-black text-[10px] sm:text-xs flex items-center gap-1 bg-[#FDBC12] hover:bg-amber-400 text-[#0A2451] transition cursor-pointer shadow-md border border-amber-300 active:scale-95"
              title="Switch to Member Portal view to act as a member"
            >
              <span>👤</span>
              <span className="hidden xs:inline sm:inline">Act as Member</span>
            </button>

            <button
              type="button"
              onClick={toggleTheme}
              className={`px-2.5 py-1.5 sm:px-3.5 sm:py-1.5 rounded-full font-black text-[10px] sm:text-xs flex items-center gap-1.5 transition cursor-pointer border shadow-xs active:scale-95 ${theme === 'light'
                  ? 'bg-amber-100 text-amber-950 border-amber-300 hover:bg-amber-200'
                  : 'bg-[#131E32] text-amber-300 border-amber-500/40 hover:bg-[#1E2B45]'
                }`}
              title="Toggle Light / Dark UI Theme"
            >
              {theme === 'light' ? '☀️' : '🌙'}
              <span className="hidden sm:inline">{theme === 'light' ? 'Light' : 'Dark'}</span>
            </button>
          </div>
        </div>

        {/* Tab Content */}
        {tabs === "NewsMediaAdmin" && <NewsMediaAdmin />}
        <div className="min-h-screen">
          {tabs === "Dashbord" && <DashboardOverview onNavigateToMembers={handleNavigateToMembers} onNavigateTab={(tab) => setTabs(tab)} />}
          {tabs === "News" && <News />}
          {tabs === "Member" && (
            editingUserId ? (
              <MemberEditPage userId={editingUserId} onBack={() => setEditingUserId(null)} />
            ) : (
              <Member filter={memberFilter} onEditMember={(id) => setEditingUserId(id)} />
            )
          )}
          {tabs === "HomeBanner" && <HomeBanner />}
          {tabs === "AboutBanner" && <AboutBanner />}
          {tabs === "MemberBanner" && <MemberBanner />}
          {tabs === "MeetingBanner" && <MeetingsBanner />}
          {tabs === "DirectorBanner" && <DirectorsBanner />}
          {tabs === "ContactBanner" && <ContactBanner />}
          {tabs === "Gallery" && <Gallery />}
          {tabs === "Testimonial" && <Testimonials />}
          {tabs === "AboutRMB" && <About />}
          {tabs === "RMBLeader" && <RMBLeader />}
          {tabs === "RMBJaipur" && <RMBJaipur />}
          {tabs === "MemberPage" && <MemberPage />}
          {tabs === "MeetingPage" && <MeetingPage />}
          {tabs === "LeadershipPage" && <LeadershipPage />}
          {tabs === "ContactPage" && <ContactPage />}
          {tabs === "FormDeatils" && <GetInTouch />}
          {tabs === "Point" && <Point />}
          {tabs === "Attendance" && <Attendance />}
          {tabs === "GDrive" && <GoogleDriveAdmin />}
          {tabs === "EventsCalendar" && <EventsCalendar />}
          {tabs === "ReportsAnalytics" && <ReportsAnalytics />}
          {tabs === "RoleManagement" && <RoleManagement />}
          {tabs === "CommitteeManagement" && <CommitteeManagement />}
          {tabs === "ActivityVerification" && <ActivityVerification />}
          {tabs === "MembershipAuditTrail" && <MembershipAuditTrail />}
          {tabs === "RbacManagement" && <RbacManagement />}
          {tabs === "ChatGPTStudio" && <ChatGPTAdminStudio />}
          {tabs === "SystemSettingsAdmin" && <SystemSettingsAdmin />}
          {tabs === "HomeSectionLayout" && <HomeSectionLayoutAdmin />}
          {tabs === "ChapterManagement" && <ChapterManagement />}
          {tabs === "TotalConnectionsReport" && <TotalConnectionsReport />}
          {tabs === "VisitorListReport" && <VisitorListReport />}
          {tabs === "NoShowReport" && <NoShowReport />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
